import React, { useState } from 'react';
import { Container, Row, Col, Card, Badge } from 'react-bootstrap';
// data
import BlogDataList from "./property-data.json";
// icon
import Icon from '@mdi/react';
import { mdiMapMarkerRadiusOutline, mdiStar, mdiArrowRightThin } from '@mdi/js';
import { Link } from 'react-router-dom';

export default function FeaturedProperties() {
    const [BlogItemList] = useState(BlogDataList);
    return (
        <>
            <section className='section section-light' id='blog'>
                <Container>
                    <Row>
                        <Col md={12}>
                            <div className='section-title-box'>
                                <h1 className='section-title'>Featured <span className='text-primary'>Properties</span></h1>
                            </div>
                        </Col>
                    </Row>

                    <Row>
                        {BlogItemList.blogItemListData.map((data, i) =>
                            <Col md={6} xxl={3} key={i}>
                                <Card className='card-hover'>
                                    <Card.Body>
                                        <img src={require(`../../images/property-img/${data.blogImg}`)} alt="" className='rounded img-fluid img-shadow blog-img' />
                                        <div className='blog-content'>
                                            <div className="d-flex justify-content-between mt-4 mb-2">
                                                <h6 className='fs-17 fw-semibold mb-0 me-2'>{data.blogTitle}</h6>
                                                <div>
                                                    <Badge bg="soft-success">For Sale</Badge>
                                                </div>
                                            </div>
                                            <div className='d-flex text-muted fs-14'>
                                                <Icon path={mdiMapMarkerRadiusOutline} className='icon-size-18 me-2' />{data.blogLocation}
                                            </div>
                                            <div className='d-flex justify-content-between align-items-center mt-3'>
                                                <div className='d-flex text-warning'>
                                                    <Icon path={mdiStar} className='icon-size-18 me-1' />
                                                    <Icon path={mdiStar} className='icon-size-18 me-1' />
                                                    <Icon path={mdiStar} className='icon-size-18 me-1' />
                                                    <Icon path={mdiStar} className='icon-size-18 me-1' />
                                                    <Icon path={mdiStar} className='icon-size-18' />
                                                </div>
                                                <h4 className='fw-bold mb-0'>{data.blogItemPrice}</h4>
                                            </div>
                                        </div>
                                    </Card.Body>
                                </Card>
                            </Col>
                        )}
                    </Row>

                    <Row className='mt-5'>
                        <Col md={12} className='text-center'>
                            <Link className="btn btn-primary" to="/PropertyList">View More <Icon path={mdiArrowRightThin} className='icon-size-20 ms-1' /></Link>
                        </Col>
                    </Row>
                </Container>
            </section>
        </>
    )
}
